import { FC, ReactNode } from 'react';
import cs from 'classnames';
import styles from './index.module.scss';

interface ICircleCore {
  color: Colors;
  children: ReactNode;
}
type Colors = 'pink' | 'yellow' | 'purple';

const CircleCore: FC<ICircleCore> = ({ color, children }) => {
  const classNames = cs([styles['circle'], styles[`circle_${color}`]]);
  return <div className={classNames}><span>{children}</span></div>;
};

export default CircleCore;
